import { createRouter, createWebHistory } from 'vue-router';
import LoginView from './views/LoginView.vue';
import DialerView from './views/DialerView.vue';
import HistoryView from './views/HistoryView.vue';
import UsageView from './views/UsageView.vue';
import SettingsView from './views/SettingsView.vue';
import AdminView from './views/AdminView.vue';

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/login', component: LoginView, meta: { public: true } },
    { path: '/', component: DialerView },
    { path: '/history', component: HistoryView },
    { path: '/usage', component: UsageView },
    { path: '/settings', component: SettingsView },
    { path: '/admin', component: AdminView, meta: { admin: true } },
  ],
});
